import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@design-system/Button';
import { Player } from '@lottiefiles/react-lottie-player';
import SuccessGreenLottie from '@/assets/success-green.json';
import * as P from '@/constants/paths';
import { QuestionGroup } from '@viome/viome-base/src/usecase/Questionnaire/Questionnaire.model';

export const QuestionnaireSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Get pre-calculated data from location state
  const nextSection = location.state?.nextSection as QuestionGroup;
  const isLast = location.state?.isLast as boolean;
  const enable_read_only_mode = location.state
    ?.enable_read_only_mode as boolean;
  const isUpdate = location.state?.isUpdate as boolean;

  const handleContinue = () => {
    if (isUpdate) {
      // If it's an update, go back to questionnaires list
      navigate('/questionnaires');
    } else if (nextSection) {
      // Navigate to the next section using pre-calculated data
      navigate(`/questionnaires/${nextSection.questioniare_group_id}`, {
        state: {
          questionnaire: {
            groupId: nextSection.questioniare_group_id,
            groupVersionId: nextSection.questionnaire_group_version_id,
            title: nextSection.name,
            description: nextSection.description,
            timing:
              nextSection.minutes_to_complete === 0
                ? '0 mins'
                : `${nextSection.minutes_to_complete} mins`,
            enable_read_only_mode,
          },
        },
      });
    } else if (isLast) {
      // No incomplete sections remain
      navigate(P.QUESTIONNAIRE_COMPLETED_PATH);
    } else {
      // Something went wrong, go back to questionnaires list
      navigate('/questionnaires');
    }
  };

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen p-4"
      data-testid="questionnaireSuccess-container"
    >
      <Player
        autoplay
        src={SuccessGreenLottie}
        keepLastFrame
        className="w-20 h-20 object-cover"
        data-testid="questionnaireSuccess-animation"
      />
      <h2
        className="typography-h1 md:text-center mt-2 mb-4 text-center"
        data-testid="questionnaireSuccess-title"
      >
        Section Completed
      </h2>
      <Button
        type="button"
        className="py-3 text-white font-semibold bg-black rounded-lg mt-8"
        data-testid="questionnaireSuccess-actionButton"
        onClick={handleContinue}
      >
        {isUpdate ? 'Done' : 'Continue'}
      </Button>
    </div>
  );
};
